import { useEffect } from 'react';
import { prefetchTranslations } from '../utils/i18nOptimizer';
import i18n from '../i18n';

/**
 * Hook to preload i18n namespaces based on current route
 * Improves perceived performance by loading translations before they're needed
 * Note: Uses window.location instead of useLocation to avoid Router dependency issues
 */
export const useI18nPreload = () => {
  useEffect(() => {
    const currentPath = window.location.pathname;
    
    // Prefetch namespaces for likely next pages based on current route
    if (currentPath.includes('/exporter/dashboard')) {
      // User is likely to navigate to these pages from dashboard
      prefetchTranslations(i18n.language, [
        'contract',
        'booking',
        'shipment',
        'clientManagement'
      ]);
    } else if (currentPath.includes('/contract')) {
      // From contract, users might go to related pages
      prefetchTranslations(i18n.language, [
        'clientManagement',
        'companyManagement',
        'shipment'
      ]);
    } else if (currentPath === '/') {
      // On home/login page, preload common dashboard namespaces
      prefetchTranslations(i18n.language, [
        'dashboard',
        'notification',
        'contract'
      ]);
    }
  }, []); // Run once on mount
};